import { useEffect, useState } from 'react';

/**
 * Page state for a server-paginated list. Any change of the filters (or of the page size) resets
 * the page: staying on page 5 of a narrowed result set would show nothing.
 */
export const usePagedList = (filters: Record<string, unknown>, defaultSize = 20) => {
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(defaultSize);
  const appliedFilters = JSON.stringify(filters);
  useEffect(() => {
    setPage(0);
  }, [appliedFilters, size]);
  return { page, size, setPage, setSize };
};
